import { moreTransactionBeforeSave } from "services/sosInventoryService/moreTransaction/beforeSave";
import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/rma/schema";
import {
  nonUtcDateTimeHandling,
  normalizeDateFields,
} from "services/utility/beforeSave";

import { OBJECT_TYPES } from "appConstants";

const OBJECT_TYPE = OBJECT_TYPES.RMA.fullString;

export function beforeSave(record) {
  let newRecord = moreTransactionBeforeSave(OBJECT_TYPE, record);
  newRecord = nonUtcDateTimeHandling(newRecord);
  newRecord = normalizeDateFields(newRecord, FIELDS_TO_TRANSFORM.DATE_FIELDS);
  return newRecord;
}
